/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79077d9339ad2083a3901f522ad14f6b>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/page';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/page/16';

/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Page16Icon = function Page16Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  if (fg('icon-object-migration')) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: NewIcon,
      appearance: "blueBold",
      size: "16",
      label: label,
      testId: testId,
      LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
        label: label,
        testId: testId
      })
    });
  } else {
    return /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    });
  }
};
Page16Icon.displayName = 'Page16Icon';
export default Page16Icon;